
<script>
  /* eslint-disable */
import Vue from "vue";
import OktaAuthRef from "../../../../auth/okta";

export default Vue.extend({
  components: {
    AuthLoader: () => import("../../components/auth-loader/auth-loader.vue"),
  },
  name: "LoginCallback",
  async beforeMount() {
    await OktaAuthRef.handleLoginRedirect(null, "/initialize");
    const idToken = this.$auth.getAccessToken();
    console.log("logged in", idToken);
    this.$router.push("/initialize");
  },
  created() {},
  render() {
    return <auth-loader />;
  },
});
</script>
